import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../App';
import './accountAdmin.css';
import { formatDateVNDate } from '../../../utils/formatDate';

function authHeader(){ const t = localStorage.getItem('token'); return t ? { Authorization: `Bearer ${t}`, 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json' }; }

export default function TeacherHistory(){
  const { user } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL || '';
  const [teachers, setTeachers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const PAGE_SIZE = 10;

  useEffect(()=>{ if(!user) return; (async ()=>{
    try{
      const res = await fetch(`${apiUrl}/api/admin/users`, { headers: authHeader() });
      if(!res.ok) return;
      const jd = await res.json(); setTeachers((jd.users || []).filter(u => u.role === 'Teacher'));
    }catch(e){ console.error(e); }
  })(); }, [user]);

  useEffect(()=>{ if(!user) return; (async ()=>{
    setLoading(true);
    try{
      let res;
      if(!selected) res = await fetch(`${apiUrl}/api/admin/teachers/history`, { headers: authHeader() });
      else res = await fetch(`${apiUrl}/api/admin/teachers/${selected}/history`, { headers: authHeader() });
      if(!res.ok){ setHistory([]); setLoading(false); return; }
      const jd = await res.json(); setHistory(jd.history || []);
    }catch(e){ console.error(e); setHistory([]); }
    setLoading(false);
  })(); }, [selected, user]);

  // reset page when history or selection changes
  useEffect(() => { setPage(1); }, [history, selected]);

  return (
    <div className="admin-wrap">
      <h2>Teacher Assignment History</h2>
      <div className="card">
        <div className="form-row">
          <select value={selected||''} onChange={e=>setSelected(e.target.value)}>
            <option value="">-- All Teachers --</option>
            {teachers.map(t => {
              const last = t.last_name || t.lastName || t.lastname || t.family_name || '';
              const first = t.first_name || t.firstName || t.firstname || t.given_name || '';
              const nm = (last || first) ? [last, first].filter(Boolean).join(' ') : (t.username || `#${t.id}`);
              return (<option key={t.id} value={t.id}>{nm}</option>);
            })}
          </select>
        </div>

        <div className="mt-12">
          {loading ? <div className="muted">Loading...</div> : (
            <table className="data-table">
              <thead><tr><th>No.</th><th>Teacher</th><th>From Class</th><th>To Class</th><th>Assigned At</th><th>Changed By</th></tr></thead>
              <tbody>
                {history.length === 0 ? <tr><td colSpan={6} className="muted">No history available</td></tr> : (
                  (() => {
                    // sort newest-first: prefer assigned_at timestamp, fall back to numeric id
                    const sorted = (history || []).slice().sort((a, b) => {
                      if (a.assigned_at && b.assigned_at) {
                        const da = new Date(a.assigned_at).getTime() || 0;
                        const db = new Date(b.assigned_at).getTime() || 0;
                        return db - da;
                      }
                      return (Number(b.id) || 0) - (Number(a.id) || 0);
                    });
                    const total = sorted.length || 0;
                    const totalPages = Math.max(1, Math.ceil(total / PAGE_SIZE));
                    const currentPage = Math.min(Math.max(1, page), totalPages);
                    const start = (currentPage - 1) * PAGE_SIZE;
                    const pageItems = sorted.slice(start, start + PAGE_SIZE);
                    return (
                      <>
                        {pageItems.map((h, idx) => {
                          const overallIdx = start + idx;
                          // try to resolve teacher full name from teachers list when possible
                          const t = (teachers || []).find(tt => String(tt.id) === String(h.teacher_id));
                          const teacherName = (() => {
                            if (t) {
                              const last = t.last_name || t.lastName || t.lastname || '';
                              const first = t.first_name || t.firstName || t.firstname || '';
                              const nm = [last, first].filter(Boolean).join(' ').trim();
                              if (nm) return nm;
                              if (t.full_name) return t.full_name;
                              if (t.username) return t.username;
                            }
                            return h.teacher_username || h.teacher_id || <b><i>Unknown</i></b>;
                          })();
                          return (
                            <tr key={h.id}>
                              <td>{total - overallIdx}</td>
                              <td>{teacherName}</td>
                              <td>{h.from_class_name || h.from_class_id || <b><i>No Class</i></b>}</td>
                              <td>{h.to_class_name || h.to_class_id || <b><i>No Class</i></b>}</td>
                              <td>{formatDateVNDate(h.assigned_at) || <b><i>No information</i></b>}</td>
                              <td>{h.changed_by_username || h.changed_by || <b><i>Unknow</i></b>}</td>
                            </tr>
                          );
                        })}

                        {/* pagination controls */}
                        {total > PAGE_SIZE && (
                          <tr><td colSpan={6} className="pagination-row">
                            <div className="pagination">
                              <button className="btn-link" onClick={() => setPage(p => Math.max(1, p - 1))} disabled={currentPage <= 1}>Prev</button>
                              {[...Array(totalPages)].map((_, i) => (
                                <button key={i} className={`btn-link ${currentPage === (i + 1) ? 'active-nav-page' : ''}`} onClick={() => setPage(i + 1)}>{i + 1}</button>
                              ))}
                              <button className="btn-link" onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={currentPage >= totalPages}>Next</button>
                            </div>
                          </td></tr>
                        )}
                      </>
                    );
                  })()
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
